
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/points/lottery/index",
      function () {
        return require("private-next-pages/app/points/lottery/index/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/points/lottery/index"])
      });
    }
  